export default function LineBarChart({ className, alt }) {
    return (
        <div role="img" aria-label={alt} className={className}>
            <svg
                className="w-full h-full"
                viewBox="0 0 405 295"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M404.106 7.7014L0.0655212 7.70115"
                    stroke="#9B9B9B"
                    strokeWidth="2"
                    stroke-dasharray="4 4"
                />
                <path
                    d="M404.106 49.5344L0.0655212 49.5342"
                    stroke="#9B9B9B"
                    strokeWidth="2"
                    stroke-dasharray="4 4"
                />
                <path
                    d="M404.106 91.3684L0.0655212 91.3681"
                    stroke="#9B9B9B"
                    strokeWidth="2"
                    stroke-dasharray="4 4"
                />
                <path
                    d="M404.106 133.201L0.0655212 133.201"
                    stroke="#9B9B9B"
                    strokeWidth="2"
                    stroke-dasharray="4 4"
                />
                <path
                    d="M404.106 175.034L0.0655212 175.034"
                    stroke="#9B9B9B"
                    strokeWidth="2"
                    stroke-dasharray="4 4"
                />
                <path
                    d="M404.106 216.867L0.0655212 216.867"
                    stroke="#9B9B9B"
                    strokeWidth="2"
                    stroke-dasharray="4 4"
                />
                <path
                    d="M404.106 258.701L0.0655212 258.701"
                    stroke="#9B9B9B"
                    strokeWidth="2"
                    stroke-dasharray="4 4"
                />
                <path
                    d="M16.1006 76.1299C16.1006 80.5482 19.6823 84.1299 24.1006 84.1299C28.5189 84.1299 32.1006 80.5482 32.1006 76.1299C32.1006 71.7116 28.5189 68.1299 24.1006 68.1299C19.6823 68.1299 16.1006 71.7116 16.1006 76.1299ZM22.6006 76.1299V164.564H25.6006V76.1299H22.6006Z"
                    fill="#FF6B6B"
                />
                <path
                    d="M24.1006 171.908V211.803"
                    stroke="#B6D9FF"
                    strokeWidth="3"
                />
                <path
                    d="M24.1006 219.146V259.041"
                    stroke="#46CE84"
                    strokeWidth="3"
                />
                <path
                    d="M45.4756 8.08887C45.4756 12.5071 49.0573 16.0889 53.4756 16.0889C57.8939 16.0889 61.4756 12.5071 61.4756 8.08887C61.4756 3.67059 57.8939 0.0888672 53.4756 0.0888672C49.0573 0.0888672 45.4756 3.67059 45.4756 8.08887ZM51.9756 8.08887V114.417H54.9756V8.08887H51.9756Z"
                    fill="#FF6B6B"
                />
                <path
                    d="M53.4757 121.762L53.4756 174.776"
                    stroke="#B6D9FF"
                    strokeWidth="3"
                />
                <path
                    d="M53.4756 182.12V259.041"
                    stroke="#46CE84"
                    strokeWidth="3"
                />
                <path
                    d="M74.8545 64.3311C74.8545 68.7493 78.4362 72.3311 82.8545 72.3311C87.2728 72.3311 90.8545 68.7493 90.8545 64.3311C90.8545 59.9128 87.2728 56.3311 82.8545 56.3311C78.4362 56.3311 74.8545 59.9128 74.8545 64.3311ZM81.3545 64.3311V93.3798H84.3545V64.3311H81.3545Z"
                    fill="#FF6B6B"
                />
                <path
                    d="M82.8545 100.724V229.825"
                    stroke="#B6D9FF"
                    strokeWidth="3"
                />
                <path
                    d="M82.8545 237.169V259.041"
                    stroke="#46CE84"
                    strokeWidth="3"
                />
                <path
                    d="M104.229 111.393C104.229 115.811 107.811 119.393 112.229 119.393C116.648 119.393 120.229 115.811 120.229 111.393C120.229 106.974 116.648 103.393 112.229 103.393C107.811 103.393 104.229 106.974 104.229 111.393ZM110.729 111.393V164.564H113.729V111.393H110.729Z"
                    fill="#FF6B6B"
                />
                <path
                    d="M112.229 171.908V211.803"
                    stroke="#B6D9FF"
                    strokeWidth="3"
                />
                <path
                    d="M112.229 219.146V259.041"
                    stroke="#46CE84"
                    strokeWidth="3"
                />
                <path
                    d="M133.608 44.4912C133.608 48.9095 137.19 52.4912 141.608 52.4912C146.027 52.4912 149.608 48.9095 149.608 44.4912C149.608 40.0729 146.027 36.4912 141.608 36.4912C137.19 36.4912 133.608 40.0729 133.608 44.4912ZM140.108 44.4912V114.418H143.108V44.4912H140.108Z"
                    fill="#FF6B6B"
                />
                <path
                    d="M141.608 121.762L141.608 174.776"
                    stroke="#B6D9FF"
                    strokeWidth="3"
                />
                <path
                    d="M141.608 182.121V259.042"
                    stroke="#46CE84"
                    strokeWidth="3"
                />
                <path
                    d="M162.983 101.05C162.983 105.468 166.565 109.05 170.983 109.05C175.402 109.05 178.983 105.468 178.983 101.05C178.983 96.6315 175.402 93.0498 170.983 93.0498C166.565 93.0498 162.983 96.6315 162.983 101.05ZM169.483 101.05V189.483H172.483V101.05H169.483Z"
                    fill="#FF6B6B"
                />
                <path
                    d="M170.983 196.828V211.803"
                    stroke="#B6D9FF"
                    strokeWidth="3"
                />
                <path
                    d="M170.983 219.146V259.041"
                    stroke="#46CE84"
                    strokeWidth="3"
                />
                <path
                    d="M192.362 146.055C192.362 150.473 195.944 154.055 200.362 154.055C204.781 154.055 208.362 150.473 208.362 146.055C208.362 141.636 204.781 138.055 200.362 138.055C195.944 138.055 192.362 141.636 192.362 146.055ZM198.862 146.055V182.417H201.862V146.055H198.862Z"
                    fill="#FF6B6B"
                />
                <path
                    d="M200.362 189.761V211.802"
                    stroke="#B6D9FF"
                    strokeWidth="3"
                />
                <path
                    d="M200.362 219.146V259.041"
                    stroke="#46CE84"
                    strokeWidth="3"
                />
                <path
                    d="M221.737 120.063C221.737 124.481 225.319 128.063 229.737 128.063C234.156 128.063 237.737 124.481 237.737 120.063C237.737 115.644 234.156 112.063 229.737 112.063C225.319 112.063 221.737 115.644 221.737 120.063ZM228.237 120.063V182.417H231.237V120.063H228.237Z"
                    fill="#FF6B6B"
                />
                <path
                    d="M229.737 189.762V211.803"
                    stroke="#B6D9FF"
                    strokeWidth="3"
                />
                <path
                    d="M229.737 219.146V259.041"
                    stroke="#46CE84"
                    strokeWidth="3"
                />
                <path
                    d="M251.116 132.578C251.116 136.997 254.698 140.578 259.116 140.578C263.534 140.578 267.116 136.997 267.116 132.578C267.116 128.16 263.534 124.578 259.116 124.578C254.698 124.578 251.116 128.16 251.116 132.578ZM257.616 132.578V194.933H260.616V132.578H257.616Z"
                    fill="#FF6B6B"
                />
                <path
                    d="M259.116 202.277V211.803"
                    stroke="#B6D9FF"
                    strokeWidth="3"
                />
                <path
                    d="M259.116 219.146V259.041"
                    stroke="#46CE84"
                    strokeWidth="3"
                />
                <path
                    d="M280.491 111.393C280.491 115.811 284.073 119.393 288.491 119.393C292.909 119.393 296.491 115.811 296.491 111.393C296.491 106.974 292.909 103.393 288.491 103.393C284.073 103.393 280.491 106.974 280.491 111.393ZM286.991 111.393V164.564H289.991V111.393H286.991Z"
                    fill="#FF6B6B"
                />
                <path
                    d="M288.491 171.908V211.803"
                    stroke="#B6D9FF"
                    strokeWidth="3"
                />
                <path
                    d="M288.491 219.146V259.041"
                    stroke="#46CE84"
                    strokeWidth="3"
                />
                <path
                    d="M309.87 134.339C309.87 138.757 313.452 142.339 317.87 142.339C322.288 142.339 325.87 138.757 325.87 134.339C325.87 129.921 322.288 126.339 317.87 126.339C313.452 126.339 309.87 129.921 309.87 134.339ZM316.37 134.339V170.535H319.37V134.339H316.37Z"
                    fill="#FF6B6B"
                />
                <path
                    d="M317.87 177.88L317.87 201.459"
                    stroke="#B6D9FF"
                    strokeWidth="3"
                />
                <path
                    d="M317.87 208.803V259.041"
                    stroke="#46CE84"
                    strokeWidth="3"
                />
                <path
                    d="M339.245 179.212C339.245 183.63 342.827 187.212 347.245 187.212C351.663 187.212 355.245 183.63 355.245 179.212C355.245 174.794 351.663 171.212 347.245 171.212C342.827 171.212 339.245 174.794 339.245 179.212ZM345.745 179.212V215.408H348.745V179.212H345.745Z"
                    fill="#FF6B6B"
                />
                <path
                    d="M347.245 222.753L347.245 232.814"
                    stroke="#B6D9FF"
                    strokeWidth="3"
                />
                <path
                    d="M347.245 240.157V259.041"
                    stroke="#46CE84"
                    strokeWidth="3"
                />
                <path
                    d="M368.624 187.054C368.624 191.472 372.206 195.054 376.624 195.054C381.042 195.054 384.624 191.472 384.624 187.054C384.624 182.635 381.042 179.054 376.624 179.054C372.206 179.054 368.624 182.635 368.624 187.054ZM375.124 187.054V223.25H378.124V187.054H375.124Z"
                    fill="#FF6B6B"
                />
                <path
                    d="M376.624 230.595L376.624 240.655"
                    stroke="#B6D9FF"
                    strokeWidth="3"
                />
                <path
                    d="M376.624 247.999V259.041"
                    stroke="#46CE84"
                    strokeWidth="3"
                />
                <rect
                    x="24.1006"
                    y="280.392"
                    width="13.8418"
                    height="13.8418"
                    fill="#FF6B6B"
                />
                <path
                    d="M48.8824 292.312V284.304H46.2364V282.372H53.6004V284.304H50.9264V292.312H48.8824ZM60.5453 290.52C62.2813 290.52 63.6393 289.078 63.6393 287.342C63.6393 285.606 62.2813 284.164 60.5453 284.164C58.8093 284.164 57.4513 285.606 57.4513 287.342C57.4513 289.078 58.8093 290.52 60.5453 290.52ZM60.5453 292.481C57.7033 292.481 55.4073 290.184 55.4073 287.342C55.4073 284.5 57.7033 282.204 60.5453 282.204C63.3873 282.204 65.6833 284.5 65.6833 287.342C65.6833 290.184 63.3873 292.481 60.5453 292.481ZM70.1257 292.312V284.304H67.4797V282.372H74.8437V284.304H72.1697V292.312H70.1257ZM75.5724 292.312L79.8564 282.372H81.6624L85.9604 292.312H83.8324L82.8664 290.044H78.6244L77.6724 292.312H75.5724ZM80.7524 285.046L79.3804 288.266H82.1104L80.7524 285.046ZM88.4687 292.312V282.372H90.4987V290.38H94.7547V292.312H88.4687Z"
                    fill="black"
                />
                <rect
                    x="127.942"
                    y="280.392"
                    width="13.8418"
                    height="13.8418"
                    fill="#46CE84"
                />
                <path
                    d="M150.89 292.312V282.372H156.938V284.304H152.92V286.362H156.07V288.294H152.92V292.312H150.89ZM164.25 290.52C165.986 290.52 167.344 289.078 167.344 287.342C167.344 285.606 165.986 284.164 164.25 284.164C162.514 284.164 161.156 285.606 161.156 287.342C161.156 289.078 162.514 290.52 164.25 290.52ZM164.25 292.481C161.408 292.481 159.112 290.184 159.112 287.342C159.112 284.5 161.408 282.204 164.25 282.204C167.092 282.204 169.388 284.5 169.388 287.342C169.388 290.184 167.092 292.481 164.25 292.481ZM172.407 292.312V282.372H176.215C178.063 282.372 179.267 283.66 179.267 285.312C179.267 286.656 178.553 287.496 177.223 287.902L180.793 292.312H178.343L174.927 288.126H174.437V292.312H172.407ZM174.437 286.39H175.977C176.747 286.39 177.251 285.984 177.251 285.312C177.251 284.626 176.747 284.234 175.977 284.234H174.437V286.39ZM182.994 292.312V282.372H189.182V284.304H185.024V286.348H188.342V288.28H185.024V290.38H189.182V292.312H182.994ZM195.25 292.481C193.668 292.481 192.338 291.808 191.624 290.702L193.178 289.4C193.668 290.142 194.508 290.576 195.334 290.576C196.132 290.576 196.664 290.184 196.664 289.61C196.664 289.05 196.272 288.658 195.278 288.322L194.438 288.028C192.828 287.468 191.988 286.544 191.988 285.186C191.988 283.324 193.402 282.204 195.348 282.204C196.58 282.204 197.63 282.624 198.484 283.576L197.14 284.962C196.664 284.388 196.076 284.108 195.362 284.108C194.676 284.108 194.032 284.403 194.032 284.99C194.032 285.592 194.508 285.858 195.572 286.236L196.37 286.53C197.826 287.076 198.736 287.972 198.736 289.484C198.736 291.262 197.294 292.481 195.25 292.481ZM203.447 292.312V284.304H200.801V282.372H208.165V284.304H205.491V292.312H203.447Z"
                    fill="black"
                />
                <rect
                    x="240.784"
                    y="280.392"
                    width="13.8418"
                    height="13.8418"
                    fill="#B6D9FF"
                />
                <path
                    d="M272.608 292.312H270.858L265.762 285.83V292.312H263.732V282.372H265.482L270.578 288.854V282.372H272.608V292.312ZM280.77 290.52C282.506 290.52 283.864 289.078 283.864 287.342C283.864 285.606 282.506 284.164 280.77 284.164C279.034 284.164 277.676 285.606 277.676 287.342C277.676 289.078 279.034 290.52 280.77 290.52ZM280.77 292.481C277.928 292.481 275.632 290.184 275.632 287.342C275.632 284.5 277.928 282.204 280.77 282.204C283.612 282.204 285.908 284.5 285.908 287.342C285.908 290.184 283.612 292.481 280.77 292.481ZM297.803 292.312H296.053L290.957 285.83V292.312H288.927V282.372H290.677L295.773 288.854V282.372H297.803V292.312ZM301.414 292.312V282.372H307.462V284.304H303.444V286.362H306.594V288.294H303.444V292.312H301.414ZM314.775 290.52C316.511 290.52 317.869 289.078 317.869 287.342C317.869 285.606 316.511 284.164 314.775 284.164C313.039 284.164 311.681 285.606 311.681 287.342C311.681 289.078 313.039 290.52 314.775 290.52ZM314.775 292.481C311.933 292.481 309.637 290.184 309.637 287.342C309.637 284.5 311.933 282.204 314.775 282.204C317.617 282.204 319.913 284.5 319.913 287.342C319.913 290.184 317.617 292.481 314.775 292.481ZM322.931 292.312V282.372H326.739C328.587 282.372 329.791 283.66 329.791 285.312C329.791 286.656 329.077 287.496 327.747 287.902L331.317 292.312H328.867L325.451 288.126H324.961V292.312H322.931ZM324.961 286.39H326.501C327.271 286.39 327.775 285.984 327.775 285.312C327.775 284.626 327.271 284.234 326.501 284.234H324.961V286.39ZM333.519 292.312V282.372H339.707V284.304H335.549V286.348H338.867V288.28H335.549V290.38H339.707V292.312H333.519ZM345.774 292.481C344.192 292.481 342.862 291.808 342.148 290.702L343.702 289.4C344.192 290.142 345.032 290.576 345.858 290.576C346.656 290.576 347.188 290.184 347.188 289.61C347.188 289.05 346.796 288.658 345.802 288.322L344.962 288.028C343.352 287.468 342.512 286.544 342.512 285.186C342.512 283.324 343.926 282.204 345.872 282.204C347.104 282.204 348.154 282.624 349.008 283.576L347.664 284.962C347.188 284.388 346.6 284.108 345.886 284.108C345.2 284.108 344.556 284.403 344.556 284.99C344.556 285.592 345.032 285.858 346.096 286.236L346.894 286.53C348.35 287.076 349.26 287.972 349.26 289.484C349.26 291.262 347.818 292.481 345.774 292.481ZM353.971 292.312V284.304H351.325V282.372H358.689V284.304H356.015V292.312H353.971Z"
                    fill="black"
                />
            </svg>
        </div>
    );
}
